var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5H6.5C5.94772 10.5 5.5 10.9477 5.5 11.5C5.5 12.0523 5.94772 12.5 6.5 12.5H7.5C8.05228 12.5 8.5 12.0523 8.5 11.5C8.5 10.9477 8.05228 10.5 7.5 10.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.5H11.5C10.9477 10.5 10.5 10.9477 10.5 11.5C10.5 12.0523 10.9477 12.5 11.5 12.5H12.5C13.0523 12.5 13.5 12.0523 13.5 11.5C13.5 10.9477 13.0523 10.5 12.5 10.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.5H16.5C15.9477 10.5 15.5 10.9477 15.5 11.5C15.5 12.0523 15.9477 12.5 16.5 12.5H17.5C18.0523 12.5 18.5 12.0523 18.5 11.5C18.5 10.9477 18.0523 10.5 17.5 10.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.5H6.5C5.94772 14.5 5.5 14.9477 5.5 15.5C5.5 16.0523 5.94772 16.5 6.5 16.5H7.5C8.05228 16.5 8.5 16.0523 8.5 15.5C8.5 14.9477 8.05228 14.5 7.5 14.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.5H11.5C10.9477 14.5 10.5 14.9477 10.5 15.5C10.5 16.0523 10.9477 16.5 11.5 16.5H12.5C13.0523 16.5 13.5 16.0523 13.5 15.5C13.5 14.9477 13.0523 14.5 12.5 14.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5H16.5C15.9477 14.5 15.5 14.9477 15.5 15.5C15.5 16.0523 15.9477 16.5 16.5 16.5H17.5C18.0523 16.5 18.5 16.0523 18.5 15.5C18.5 14.9477 18.0523 14.5 17.5 14.5Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.5H6.5C5.94772 18.5 5.5 18.9477 5.5 19.5C5.5 20.0523 5.94772 20.5 6.5 20.5H7.5C8.05228 20.5 8.5 20.0523 8.5 19.5C8.5 18.9477 8.05228 18.5 7.5 18.5Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.5H11.5C10.9477 18.5 10.5 18.9477 10.5 19.5C10.5 20.0523 10.9477 20.5 11.5 20.5H12.5C13.0523 20.5 13.5 20.0523 13.5 19.5C13.5 18.9477 13.0523 18.5 12.5 18.5Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.5H16.5C15.9477 18.5 15.5 18.9477 15.5 19.5C15.5 20.0523 15.9477 20.5 16.5 20.5H17.5C18.0523 20.5 18.5 20.0523 18.5 19.5C18.5 18.9477 18.0523 18.5 17.5 18.5Z",
    fill: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 3H21.5C22.6046 3 23.5 3.89551 23.5 5V22C23.5 23.1045 22.6046 24 21.5 24H2.5C1.39543 24 0.5 23.1045 0.5 22V5C0.5 3.89551 1.39543 3 2.5 3H4C4.27614 3 4.5 3.22388 4.5 3.5V5.75C4.5 6.16431 4.83578 6.5 5.25 6.5C5.66422 6.5 6 6.16431 6 5.75V1C6 0.447754 6.44772 0 7 0C7.55228 0 8 0.447754 8 1V2.75098C8.00055 2.88867 8.11232 3 8.25 3H14.5C14.7761 3 15 3.22388 15 3.5V5.75C15 6.16431 15.3358 6.5 15.75 6.5C16.1642 6.5 16.5 6.16431 16.5 5.75V1C16.5 0.447754 16.9477 0 17.5 0C18.0523 0 18.5 0.447754 18.5 1V2.75C18.5 2.88818 18.6119 3 18.75 3ZM21 22C21.2761 22 21.5 21.7761 21.5 21.5V9.5C21.5 9.22388 21.2761 9 21 9H3C2.72386 9 2.5 9.22388 2.5 9.5V21.5C2.5 21.7761 2.72386 22 3 22H21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.bb904b41.svg";
export { ForwardRef as ReactComponent };